// src/services/auth.js

function decodeJwtPayload(token) {
  try {
    const base64 = token.split(".")[1].replace(/-/g, "+").replace(/_/g, "/");
    return JSON.parse(atob(base64));
  } catch {
    return null;
  }
}

function isExpired(token) {
  if (!token) return true;
  const payload = decodeJwtPayload(token);
  if (!payload?.exp) return true;
  return Date.now() / 1000 > payload.exp;
}

function clearSession() {
  localStorage.removeItem("token");
  localStorage.removeItem("role");
  localStorage.removeItem("userData");
}

export function getToken() {
  const token = localStorage.getItem("token");
  if (isExpired(token)) {
    clearSession();
    return null;
  }
  return token;
}

export function getRole() {
  const token = localStorage.getItem("token");
  if (isExpired(token)) {
    clearSession();
    return null;
  }
  return localStorage.getItem("role");
}

export function getUserData() {
  const raw = localStorage.getItem("userData");
  return raw ? JSON.parse(raw) : null;
}

export function setUserData(data) {
  localStorage.setItem("userData", JSON.stringify(data));
}

export function logout() {
  clearSession();
  window.location.href = "/login";
}

export async function login(username, password) {
  const res = await fetch("/api/auth/login", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ username, password }),
  });
  if (!res.ok) throw new Error("Credenciales inválidas");
  const data = await res.json();
  localStorage.setItem("token", data.token);
  localStorage.setItem("role", data.role);
  return data;
}
